export default __webpack_public_path__ + "static/media/ic_close.6c9a4ba7.svg";